import { SlotIcon } from '@coop/cds-components';
import * as React from 'react';

import type { BadgeProps } from './Badge.types';

import { getBadgeClasses } from './Badge.utils';

/**
 * @deprecated Use the Badge component from CDS instead.
 */
const Badge = React.forwardRef<HTMLDivElement, React.PropsWithChildren<BadgeProps>>(
    (props, ref) => {
        const classes = getBadgeClasses(props);

        return (
            <div
                ref={ref}
                className={classes}
                style={{
                    ...props.style,
                    top: props.top,
                    right: props.right,
                    bottom: props.bottom,
                    left: props.left,
                    transform: [
                        props.offsetX !== undefined && `translateX(${props.offsetX})`,
                        props.offsetY !== undefined && `translateY(${props.offsetY})`,
                    ]
                        .filter(Boolean)
                        .join(' '),
                }}
                aria-hidden={props.ariaHidden}
            >
                {props.leftIcon && (
                    <SlotIcon
                        icon={props.leftIcon}
                        size="small"
                        aria-hidden
                        style={{ marginRight: 4 }}
                    />
                )}
                {props.children}
            </div>
        );
    },
);

export default Badge;
